import { combineReducers } from '@reduxjs/toolkit';
import listOfBrands from 'redux/list-of-brands/reducer';
import sidebar from 'redux/sidebar/reducer';

export default combineReducers({
  listOfBrands: listOfBrands,
  sidebar: sidebar,
});
